import styled from 'styled-components';

export const FormWrapper = styled.div``;
